export default "__VITE_ASSET__iFxTPTdY__"